<template>
  <span>
    <div class="d-none d-xl-block">
      <div class="row mb-2 no-gutter">
        <div class="col-xl-3">
            <div class="card mb-0">
              <div class="card-header">Kvarvarande semester</div>
              <div class="card-body">
                <table class="table table-borderless table-sm mb-0" style="width:100%">
                  <tr>
                    <td>Betalda:</td>
                    <td class="text-right" >{{salarySpecification.vacation.paid}}</td>
                  </tr>
                  <tr>
                    <td>Sparade:</td>
                    <td class="text-right">{{salarySpecification.vacation.saved}}</td>
                  </tr>
                  <tr>
                    <td>Förskott:</td>
                    <td class="text-right">{{salarySpecification.vacation.advance}}</td>
                  </tr>
                  <tr>
                    <td>Komptid:</td>
                    <td class="text-right">{{salarySpecification.compensationTime}}</td>
                  </tr> 
                  <tr>
                    <td>&nbsp;</td>
                    <td class="text-right">&nbsp;</td>
                  </tr>                                                                  
                </table>
              </div>
            </div> 
        </div>
        <div class="col-xl-3">
            <div class="card mb-0">
              <div class="card-header">Total lön</div>
              <div class="card-body">
                <table class="table table-borderless table-sm mb-0" style="width:100%">
                  <tr>
                    <td>Bruttolön:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.grossSalary | currency}}</td>
                  </tr>
                  <tr>
                    <td>Förmån:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.benefit | currency}}</td>
                  </tr>
                  <tr>
                    <td>Skatt:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.tax | currency}}</td>
                  </tr>
                  <tr>
                    <td>Löneskuld:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.debt | currency}}</td>
                  </tr>     
                  <tr>
                    <td>&nbsp;</td>
                    <td class="text-right">&nbsp;</td>
                  </tr>                                                              
                </table>              
              </div>
            </div> 
        </div>
        <div class="col-xl-3">
          <div class="card mb-0">
            <div class="card-header">Skatt beräknad på</div>
            <div class="card-body">
              <table class="table table-borderless table-sm mb-0" style="width:100%">
                <tr>
                  <td>Bruttolön:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.grossSalary | currency}}</td>
                </tr>
                <tr>
                  <td>Förmån:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.benefit | currency}}</td>
                </tr>
                <tr>
                  <td>Tabell:</td>
                  <td class="text-right">{{salarySpecification.salary.taxTable}}</td>
                </tr>
                <tr>
                  <td>Engångsskatt:</td>
                  <td class="text-right">{{salarySpecification.oneOffTaxation}}%</td>
                </tr>
                <tr>
                  <td>Arbetsgivaravgift:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.payrollTax | currency}}</td>
                </tr>                                                                
              </table>              
            </div>
          </div> 
        </div> 
        <div class="col-xl-3">
            <div class="card mb-0">
              <div class="card-header">Utbetalning</div>
              <div class="card-body">
                <table class="table table-borderless table-sm mb-0" style="width:100%">
                  <tr>
                    <td>Bruttolön:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryValues.grossSalary | currency}}</td>
                  </tr>
                  <tr>
                    <td>Ersättning:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryValues.refund | currency}}</td>
                  </tr>
                  <tr>
                    <td>Skatt:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryValues.tax | currency}}</td>
                  </tr>
                  <tr>
                    <td>Öresutjämning:</td>
                    <td class="text-right">{{salarySpecification.calculatedSalaryValues.rounding | currency}}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td class="text-right">&nbsp;</td>
                  </tr>                                                                                 
                </table>  
              </div>
            
            </div> 
        </div>                   
      </div>
    </div>


    <div class="row mb-1 d-xl-none">
      <div class="col-12 col-md-6">
          <div class="card mb-2">
            <div class="card-header">Kvarvarande semester</div>
            <div class="card-body">
              <table class="table table-borderless table-sm mb-0" style="width:100%">
                <tr>
                  <td>Betalda:</td>
                  <td class="text-right" >{{salarySpecification.vacation.paid}}</td>
                </tr>
                <tr>
                  <td>Sparade:</td>
                  <td class="text-right">{{salarySpecification.vacation.saved}}</td>
                </tr>
                <tr>
                  <td>Förskott:</td>
                  <td class="text-right">{{salarySpecification.vacation.advance}}</td>
                </tr>
                <tr>
                  <td>Komptid:</td>
                  <td class="text-right">{{salarySpecification.compensationTime}}</td>
                </tr> 
                <tr>
                  <td>&nbsp;</td>
                  <td class="text-right">&nbsp;</td>
                </tr>                                                                  
              </table>
            </div>
          </div> 
      </div>
      <div class="col-12 col-md-6">
          <div class="card mb-2">
            <div class="card-header">Total lön</div>
            <div class="card-body">
              <table class="table table-borderless table-sm mb-0" style="width:100%">
                <tr>
                  <td>Bruttolön:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.grossSalary | currency}}</td>
                </tr>
                <tr>
                  <td>Förmån:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.benefit | currency}}</td>
                </tr>
                <tr>
                  <td>Skatt:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.tax | currency}}</td>
                </tr>
                <tr>
                  <td>Löneskuld:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryTotalValues.debt | currency}}</td>
                </tr>     
                <tr>
                  <td>&nbsp;</td>
                  <td class="text-right">&nbsp;</td>
                </tr>                                                              
              </table>              
            </div>
          </div> 
      </div>
      <div class="col-12 col-md-6">
        <div class="card mb-2">
          <div class="card-header">Skatt beräknad på</div>
          <div class="card-body">
            <table class="table table-borderless table-sm mb-0" style="width:100%">
              <tr>
                <td>Bruttolön:</td>
                <td class="text-right">{{salarySpecification.calculatedSalaryValues.grossSalary | currency}}</td>
              </tr>
              <tr>
                <td>Förmån:</td>
                <td class="text-right">{{salarySpecification.calculatedSalaryValues.benefit | currency}}</td>
              </tr>
              <tr>
                <td>Tabell:</td>
                <td class="text-right">{{salarySpecification.salary.taxTable}}</td>
              </tr>
              <tr>
                <td>Engångsskatt:</td>
                <td class="text-right">{{salarySpecification.oneOffTaxation}}%</td>
              </tr>
              <tr>
                <td>Arbetsgivaravgift:</td>
                <td class="text-right">{{salarySpecification.calculatedSalaryValues.payrollTax | currency}}</td>
              </tr>                                                                
            </table>              
          </div>
        </div> 
      </div> 
      <div class="col-12 col-md-6">
          <div class="card mb-2">
            <div class="card-header">Utbetalning</div>
            <div class="card-body">
              <table class="table table-borderless table-sm mb-0" style="width:100%">
                <tr>
                  <td>Bruttolön:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.grossSalary | currency}}</td>
                </tr>
                <tr>
                  <td>Ersättning:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.refund | currency}}</td>
                </tr>
                <tr>
                  <td>Skatt:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.tax | currency}}</td>
                </tr>
                <tr>
                  <td>Öresutjämning:</td>
                  <td class="text-right">{{salarySpecification.calculatedSalaryValues.rounding | currency}}</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td class="text-right">&nbsp;</td>
                </tr>                                                                                 
              </table>  
            </div>          
          </div> 
      </div>                   
    </div>    

  </span>
</template>

<script>
export default {

  props: {
    salarySpecification: null
  }
};
</script>

<style>
/* remove spacing between middle columns */
.row.no-gutter [class*='col-']:not(:first-child):not(:last-child) {
  padding-right:4px;
  padding-left:4px;
}
/* remove right padding from first column */
.row.no-gutter [class*='col-']:first-child {
  padding-right:4px;
}

/* remove left padding from first column */
.row.no-gutter [class*='col-']:last-child {
  padding-left:4px;
}
</style>
</script>

<style>
</style>
